import { useCallback, useEffect } from 'react';

import {
  MarqueDto,
  SearchMarqueUsingSpecsUsingGETQueryParamsFilters,
} from 'lib_api/lib/api/gen';

import { useSearchMarque } from '../search/useSearchMarque';
import { useSearchWithPagination } from '../search/useSearchWithPagination';

const INITIAL_MARQUE_FILTERS: SearchMarqueUsingSpecsUsingGETQueryParamsFilters =
  {
    page: 1,
    pageSize: 30,
    types: ['EXACTE', 'INCONNUE'],
  };

export const useFetchMarques = (
  prioritaire: boolean,
): {
  inProgress: boolean;
  marques: MarqueDto[];
  search: (query: string) => void;
  paginate: () => void;
} => {
  const searchMarque = useSearchMarque();

  const fetch = useCallback(
    (filters: SearchMarqueUsingSpecsUsingGETQueryParamsFilters) => {
      return searchMarque({
        filters: {
          ...filters,
        },
        sorts: {
          libelle: true,
        },
      });
    },
    [],
  );

  const { inProgress, options, search, pagination, filters, fetchOptions } =
    useSearchWithPagination(
      fetch,
      {
        ...INITIAL_MARQUE_FILTERS,
        prioritaire,
      },
      response => response.results.referenceDtoList,
    );

  useEffect(() => {
    fetchOptions(filters.page === 1);
  }, [filters]);

  const paginate = () => {
    pagination(filters.page);
  };

  return {
    inProgress,
    marques: options,
    search,
    paginate,
  };
};
